import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private secretKey = 'rPzsuPlMzswOgB3eqPYLa6rz4PqFmQ3R';  //// do not change it. Same key is used in API application
  constructor() { }
   // Encrypt method
  encrypt(plainText: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey.substring(0, 32)); // AES-256 key (32 bytes)
    const iv = CryptoJS.lib.WordArray.random(16); // Generate random IV (16 bytes)

    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Prepend IV to the ciphertext
    const encryptedTextWithIv = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(encryptedTextWithIv); // Convert to Base64 string
  }

  // Decrypt method
  decrypt(cipherText: string): string {
    const encryptedTextWithIv = CryptoJS.enc.Base64.parse(cipherText);

    // Extract IV (first 16 bytes)
    const iv = CryptoJS.lib.WordArray.create(encryptedTextWithIv.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedTextWithIv.words.slice(4));

    const key = CryptoJS.enc.Utf8.parse(this.secretKey.substring(0, 32)); // AES-256 key (32 bytes)

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return CryptoJS.enc.Utf8.stringify(decrypted); // Convert decrypted data to string
  }
}
